module.exports = __webpack_public_path__ + "img/1a625b1.jpg";